import { Image } from "@/models/image";

export class Helper {
    public static getImageUrl(image: Image, width: number, height: number): string {
        if (
            image.urlTemplate &&
            image.urlTemplate.length > 0 &&
            image.urlTemplate.indexOf("---WIDTH---") > -1 &&
            image.urlTemplate.indexOf("---HEIGHT---") > -1
        ) {
            return image.urlTemplate.replace("---WIDTH---", `${width}`).replace("---HEIGHT---", `${height}`);
        } else {
            return image.urlTemplate;
        }
    }

    public static setLocalStorageItem(key: string, value: string): void {
        localStorage.setItem(key, value);
    }
    public static getLocalStorageItem(key: string): string {
        return localStorage.getItem(key) as string;
    }
    public static removeLocalStorageItem(key: string): void {
        localStorage.removeItem(key);
    }

    public static isValidEmail(email: string): boolean {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    public static sendMessageToParentWindow(message: unknown): void {
        if (window && window.parent) {
            window.parent.postMessage(message, "*");
        }
    }
}
